import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';

interface PriceDisplayProps {
  price: number;
  className?: string;
  showCurrency?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({ 
  price, 
  className = '', 
  showCurrency = false,
  size = 'md'
}) => {
  const { formatPrice, currency } = useCurrency();
  
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base font-bold'
  };

  return (
    <span className={`${sizeClasses[size]} ${className}`}>
      {formatPrice(price)}
      {showCurrency && ` ${currency.code}`}
    </span>
  );
};

export default PriceDisplay;